import { useTranslation } from "react-i18next";

export const COLOR_AZUL_MAIN = '#1F69AD';
export const COLOR_ROJO = '#DC3545';
export const COLOR_VERDE = '#1c8030';
export const COLOR_NARANJA = '#efa609ff';

export const COLORS_VALUES = {
    blue: 1,
    red: 2,
    green: 3,
    yellow: 4
};

export const useColors = () => {
    const { t } = useTranslation();
    const COLORS_VALUES = [
        { label: t("label_colors_blue"), value: 1, backgroundColor: "blue" },
        { label: t("label_colors_red"), value: 2, backgroundColor: "red" },
        { label: t("label_colors_green"), value: 3, backgroundColor: "green" },
        { label: t("label_colors_yellow"), value: 4, backgroundColor: "yellow" },
    ];
    return COLORS_VALUES;
};